import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { BuildPage } from './pages/build/build.page';
import { CallbackPage } from './pages/callback/callback.page';
import { LandingPage } from './pages/landing/landing.page';
import { AnnouncementsComponent } from './pages/announcements/announcements.component';
import { GetStartedPageComponent } from './pages/components-get-started/get-started-page.component';
import { StylingPageComponent } from './pages/styling/styling-page/styling-page.component';
import { IconGetStartedPageComponent } from './pages/icons-get-started/icon-get-started-page.component';

const routes: Routes = [
    { path: '', component: LandingPage },
    { path: 'callback', component: CallbackPage },
    { path: 'build', component: BuildPage, data: { page: 'home' } },
    { path: 'build/search', component: BuildPage, data: { page: 'search' } },
    {
        path: 'build/introduction/whats-new',
        component: BuildPage,
        data: { page: 'posts' },
    },
    {
        path: 'build/introduction/announcements',
        component: BuildPage,
        children: [
            {
                path: '',
                component: AnnouncementsComponent,
            },
            {
                path: ':slug',
                component: AnnouncementsComponent,
            },
        ],
    },
    {
        path: 'build/components/getting-started',
        component: BuildPage,
        children: [
            {
                path: '',
                component: GetStartedPageComponent,
            },
            {
                path: 'iconography',
                component: IconGetStartedPageComponent,
            },
        ],
    },
    {
        path: 'build/foundations/styling',
        component: BuildPage,
        children: [
            {
                path: '',
                component: StylingPageComponent,
            },
        ],
    },
    {
        path: 'build/foundations/personas',
        redirectTo: 'build/user-research/personas',
        pathMatch: 'prefix',
    },
    {
        path: 'build/components/linear-progress',
        redirectTo: 'build/components/progress-indicators',
        pathMatch: 'prefix',
    },
    {
        path: 'build/user-research/persona-gallery',
        redirectTo: 'build/user-research/personas',
        pathMatch: 'prefix',
    },
    {
        path: 'build/user-research/personas/gallery',
        redirectTo: 'build/user-research/personas',
        pathMatch: 'prefix',
    },
    {
        path: 'app',
        loadChildren: () =>
            import('./example/example-app.routes').then(
                (m) => m.EXAMPLE_APP_ROUTES,
            ),
    },
    { path: '**', component: BuildPage, data: { page: 'cms' } },
];

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64],
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
